import React, { useEffect, useRef, useState } from "react";
import { Modal, Form, Select } from "antd";
import styled from "styled-components";
import { ButtonFilled, ButtonOutlined } from "reusableComponent/UIButtons";
import { useDispatch, useSelector } from "react-redux";
import { getClientid, getUserInfo, getUserList } from "redux/selectors";
import { CALL_API } from "common/API";
import { STATUS_CODE } from "common/Constants";
import { setAssetsList } from "redux/actions";

const ModalWrap = styled(Modal)`
  .ant-modal-content {
    border-radius: 12px;
  }
`;

const AssignAssetModal = ({ open, onClose, asset, getAssets }) => {
  console.log("asset12-->", asset);
  const [form] = Form.useForm();
  const userList = useSelector(getUserList);
  const userInfo = useSelector(getUserInfo);
  const clientId = useSelector(getClientid);
  const containerRef = useRef(null);
  const [loading, setLoading] = useState(false);
  const dispatch = useDispatch();

  useEffect(() => {
    if (!open) {
      form.resetFields();
    }
  }, [open, form]);

  const fetchMasterData = async (fetch_master_data) => {
    const { code, assetsCategories } = await CALL_API(
      `assets/getassets/all`,
      "get"
    );
    if (code === STATUS_CODE.SUCCESS) {
      dispatch(setAssetsList(assetsCategories));
    }
  };

  const handleSubmit = async () => {
    try {
      setLoading(true);
      const values = await form.validateFields();

      if (!values.employee) {
        setLoading(false);
        return;
      }

      const payload = {
        assigned_to: values.employee,
        assigned_on: new Date(),
        assigned_by: userInfo.userid,
        assetstatus: "Assigned",
        categorytype: asset?.categorytype,
        model: asset?.model,
        assetname: asset?.assetname,
        categoryid: asset?.categoryid,
        categoryname: asset?.categoryname,
        masterid: asset?.masterid,
      };
      const { code } = await CALL_API(
        `/assets/assignassets/${asset?.assetid}`,
        "patch",
        payload
      );

      if (code === STATUS_CODE.SUCCESS) {
        getAssets();
        await fetchMasterData(true);
        form.resetFields();
        onClose();
      }
      setLoading(false);
    } catch (error) {
      console.log(error);
      setLoading(false);
    }
  };

  return (
    <div ref={containerRef}>
      <ModalWrap
        open={open}
        footer={null}
        onCancel={() => {
          form.resetFields();
          onClose();
        }}
        centered
        width={500}
        destroyOnClose
        title={`Assigning Asset - ${asset?.categoryname || ""}`}
      >
        <Form form={form} layout="vertical">
          <Form.Item label="Asset Name">
            <div>{asset?.assetname || "-"}</div>
          </Form.Item>

          <Form.Item
            label="Choose Employee to Assign"
            name="employee"
            rules={[
              {
                required: true,
                message: "Please select an employee",
              },
            ]}
          >
            <Select
              showSearch
              placeholder="Select Employee"
              options={userList
                ?.filter((item) => item?.statusid === "1")
                ?.map((item) => ({
                  label: `${item.fullname}`,
                  value: item.userid,
                }))}
              filterOption={(input, option) =>
                option?.label?.toLowerCase()?.includes(input.toLowerCase())
              }
              filterSort={(a, b) =>
                a?.label?.toLowerCase()?.localeCompare(b?.label?.toLowerCase())
              }
              getPopupContainer={(trigger) => trigger.parentElement}
            />
          </Form.Item>

          <div className="text-end">
            <ButtonOutlined
              onClick={() => {
                form.resetFields();
                onClose();
              }}
            >
              Cancel
            </ButtonOutlined>

            <ButtonFilled
              onClick={handleSubmit}
              style={{ marginLeft: 10 }}
              loading={loading}
            >
              Assign
            </ButtonFilled>
          </div>
        </Form>
      </ModalWrap>
    </div>
  );
};

export default AssignAssetModal;
